export function registerServiceWorker() {
    return new Promise((resolve, reject) => {
        window.addEventListener('load', () => {
            if ('serviceWorker' in navigator) {
                navigator.serviceWorker.register('/service-worker', { scope: '/' }).then(resolve, reject);
            }
        });
    });
}

export function unregisterServiceWorker() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready.then(registration => {
            return registration.unregister();
        });
    }
}
